import createApiServices from "./createApiServices"
import {BACKEND_URL} from "../ConfigUrlApi"

const api = createApiServices({baseUrl: BACKEND_URL})
const apiExport = createApiServices({baseUrl: 'https://admin.callstack.vn:9909/api'})

export const searchTenantHub = (username, payload) => {
    return api.makeRequestQueue({
        url: `/v1.0/base/searchTenantHub?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const addTenantHub = (username, payload) => {
    return api.makeRequestQueue({
        url: `/setting/tenant/addTenantHub?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const updateTenantHub = (username, payload) => {
    return api.makeRequestQueue({
        url: `/v1.0/base/updateTenantHub?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const getListTenantRouting = (username, tenantId) => {
    return api.makeRequestQueue({
        url: `/v1.0/base/getListTenantRouting?userName=${username}&tenantId=${tenantId}`,
        method: 'POST'
    })
}

export const searchTelco = (username) => {
    return api.makeRequestQueue({
        url: `/v1.0/base/searchTelco?userName=${username}`,
        method: 'POST'
    })
}

export const addTenantRouting = (username, payload) => {
    return api.makeRequestQueue({
        url: `/v1.0/base/addTenantRouting?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const updateTenantRouting = (username, payload) => {
    return api.makeRequestQueue({
        url: `/v1.0/base/updateTenantRouting?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const getListTenantFee = (username, tenantId) => {
    return api.makeRequestQueue({
        url: `/hub/getListTenantFee?userName=${username}`,
        method: 'POST',
        data: {tenantId}
    })
}

export const addTenantFee = (username, payload) => {
    return api.makeRequestQueue({
        url: `/hub/addTenantFee?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const updateTenantFee = (username, payload) => {
    return api.makeRequestQueue({
        url: `/hub/updateTenantFee?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const editTenantFee = (username, payload) => {
    return api.makeRequestQueue({
        url: `/hub/editTenantFee?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const getListIp = (username, payload = {}) => {
    return api.makeRequestQueue({
        url: `/hub/getListIp?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const addTenantIp = (username, payload) => {
    return api.makeRequestQueue({
        url: `/hub/addTenantIp?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const updateTenantIp = (username, payload) => {
    return api.makeRequestQueue({
        url: `/hub/updateTenantIp?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const getListTenantNumber = (username, payload) => {
    return api.makeRequestQueue({
        url: `/hub/getListTenantNumber?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const bookPhoneNumber = (username, payload) => {
    return api.makeRequestQueue({
        url: `/hub/bookPhoneNumber?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const getListShortPhoneByTenant = (username, payload) => {
    return api.makeRequestQueue({
        url: `/hub/getListShortPhoneByTenant?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const isolationNumberByTenant = (username, payload) => {
    return api.makeRequestQueue({
        url: `/hub/isolationNumberByTenant?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const addNumberToTest = (username, payload) => {
    return api.makeRequestQueue({
        url: `/hub/addNumberToTest?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const evictOrCancelPhoneNumber = (username, payload, type) => {
    return api.makeRequestQueue({
        url: `/hub/evictOrCancelPhoneNumber?userName=${username}&action=${type}`,
        method: 'POST',
        data: payload
    })
}

export const togglePhoneNumber = (username, payload, type) => {
    return api.makeRequestQueue({
        url: `/hub/adminBlockPhone?userName=${username}&action=${type}`,
        method: 'POST',
        data: payload
    })
}

export const reportDetailFeeGGSheet = (username, payload) => {
    return apiExport.makeRequestQueue({
        url: `/hub/reportDetailFeeCSV?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const reportDetailFeeGGSheetNew = (username, payload) => {
    return api.makeRequestQueue({
        url: `/hub/reportDetailFeeGGSheet?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const getListTenantSubFee = (username, tenantId) => {
    return api.makeRequestQueue({
        url: `/hub/getListTenantSubFee?userName=${username}&tenantId=${tenantId}`,
        method: 'GET'
    })
}

export const updateTenantSubFee = (username, tenantSubFeeId, payload) => {
    return api.makeRequestQueue({
        url: `/hub/updateTenantSubFee?userName=${username}&tenantSubFeeId=${tenantSubFeeId}`,
        method: 'POST',
        data: payload
    })
}

export const getListTenantShortPhone = (username, tenantId) => {
    return api.makeRequestQueue({
        url: `/tenantShortPhone/getListTenantShortPhone?userName=${username}&tenantId=${tenantId}`,
        method: 'GET',
    })
}

export const getShortPhoneSeq = (username) => {
    return api.makeRequestQueue({
        url: `/tenantShortPhone/getShortPhoneSeq?userName=${username}`,
        method: 'GET',
    })
}

export const addTenantShortPhone = (username, payload) => {
    return api.makeRequestQueue({
        url: `/tenantShortPhone/addTenantShortPhone?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const updateTenantShortPhone = (username, tenantShortPhoneId, payload) => {
    return api.makeRequestQueue({
        url: `/tenantShortPhone/updateTenantShortPhone?userName=${username}&tenantShortPhoneId=${tenantShortPhoneId}`,
        method: 'PUT',
        data: payload
    })
}

export const getTopUpHistory = (username, pager, tenantId) => {
    return api.makeRequestQueue({
        url: `v1.0/base/getTopUpHistory?userName=${username}&tenantId=${tenantId}&page=${pager.page}&size=${pager.limit}`,
        method: 'POST'
    })
}

export const movePhoneNumber = (username, payload) => {
    return api.makeRequestQueue({
        url: `/hub/movePhoneNumber?userName=${username}`,
        method: 'POST',
        data: payload
    })
}

export const transferShortPhone = (username, payload) => {
    return api.makeRequestQueue({
        url: `/tenantShortPhone/transferShortPhone?userName=${username}`,
        method: 'POST',
        data: payload
    })
}